<template>
    <div>
      <base-navigation></base-navigation>
   
    <div class="container">
      <h4>Katani Legends</h4>
      <p class="message">{{ message }}</p>
      <br>
      <br>
      <div class="table-container">
        <table>
          <tbody>
            <tr v-for="(item, index) in collections" :key="item.id">
              <!-- `${index + 1}. ${item.display_names} - ${this.formatCurrency(item.transAmount)}` -->
              <td>{{ index + 1 }} </td>
             
              <td>{{ item.display_names }}</td>
              <td>{{ formatCurrency(item.TransAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="total-container">
        <br>
        List autopopulates after paying
        <br> 
        <strong>Total: {{ formatCurrency(totalAmount) }}</strong>
      </div>
      <button @click="copyTableData" class="copy-button">Copy Data</button>
    </div>
  </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    name: "CollectionsTable",
    data() {
      return {
        message:          "*Katani legends Standing with Makori.  Lets support our own who lost his mother. Use Roberms collection  paybill *4112827*,  account *50542#YourName as you want it to appear in the contribution list e.g 50542#Mosomi*",
      };
    },
    computed: {
      ...mapGetters(["collections"]),
      totalAmount() {
        return this.collections.reduce(
          (total, item) => total + item.TransAmount,
          0
        );
      },
      collections() {
        return  this.$store.getters.collections.filter(code=>code.clinet_code =='50542').filter(pr=>pr.processed !=1)
       
      },
    },
    methods: {
      formatCurrency(amount) {
        return new Intl.NumberFormat("en-KE", {
          style: "currency",
          currency: "KES",
          minimumFractionDigits: 0,
        }).format(amount);
      },
      copyTableData() {
        const rows = [
      [this.message],
      [" "], // Only a small space to separate message and data
      ...this.collections.map((item, index) => [
        `${index + 1}. ${item.display_names} - ${item.TransAmount}` // No currency here
      ]),
      [`*Total: ${this.formatCurrency(this.totalAmount)}*`], // Bold total with asterisk for WhatsApp
    ];
  
    const tableText = rows.map((row) => row.join("   ")).join("\n"); // Added minimal spacing and line breaks
    navigator.clipboard
          .writeText(tableText)
          .then(() => {
            alert(" data copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy table data: ", err);
          });
      },
    },
    created() {
      this.$store.dispatch('LoadCollections');  
      
      
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 600px;
    margin: 20px auto;
    padding: 15px;
    font-family: Arial, sans-serif;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: #fff;
  }
  
  h2 {
    text-align: center;
    color: #007bff;
    font-size: 1.8rem;
  }
  
  .message {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    text-align: center;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    text-align: center;
  }
  
  td {
    padding: 12px;
    text-align: center;
    border: 1px solid #ddd;
    font-size: 0.9rem;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #f1f1f1;
  }
  
  .total-container {
    margin-top: 15px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  .copy-button {
    display: block;
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .copy-button:hover {
    background-color: #0056b3;
  }
  
  /* Responsive Design */
  @media (max-width: 600px) {
    h2 {
      font-size: 1.5rem;
    }
    .message {
      font-size: 0.9rem;
    }
    table td {
      font-size: 0.8rem;
    }
    .copy-button {
      font-size: 0.9rem;
    }
  }
  </style>
  
